export default "__VITE_ASSET__CNWkvnpa__"